import React from 'react'

import { Button, Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import { FILLING_GUIDE_MEDICAL_RECORD } from 'settings/_storageFlagsSettings'

import { ReactComponent as ScheduleCardExampleSvg } from 'static/svg/schedule-card-example-animation-medical-record.svg'

import * as S from './styles'

interface FillingGuideMedicalRecordModalProps {
  onClose: () => void
}

export function FillingGuideMedicalRecordModal({
  onClose,
}: FillingGuideMedicalRecordModalProps): JSX.Element {
  return (
    <ModalGeneric
      modalTitle={
        <S.TitleContainer>
          <ScheduleCardExampleSvg />
          <Typography
            center
            weight='bold'
            variant='content1'
          >
            Para preencher mais tarde, é só interagir com o ícone à direita das consultas já realizadas.
          </Typography>
        </S.TitleContainer>
      }
      onCloseModal={onClose}
    >
      <S.FillingGuideMedicalRecordModalContainer>
        <Typography
          center
          variant='content2'
        >
          A sinalização em vermelho deixará de ser exibida somente após o preenchimento.
        </Typography>

        <Typography
          center
          variant='content2'
        >
          Preencher os prontuários até o final do dia de realização de consultas <strong>é uma responsabilidade de todos os profissionais que atendam na Telavita</strong>.
        </Typography>

        <Button
          variant='contained'
          onClick={onClose}
          uppercase={false}
        >
          Entendi
        </Button>

        <Button
          variant='text'
          uppercase={false}
          onClick={() => {
            localStorage.setItem(FILLING_GUIDE_MEDICAL_RECORD, 'true')
            onClose()
          }}
        >
          Não mostrar mais esta mensagem
        </Button>
      </S.FillingGuideMedicalRecordModalContainer>
    </ModalGeneric>
  )
}